/*
 * Lib Module Textareas
 */

Lib.Textarea = (function() {
    var self = {};

    $(Lib).on('document.ready', function() {
        self.enableAutosize($('textarea[data-autosize]:not([data-wysiwyg])'));
        self.enableCounter($('textarea[data-counter]:not([data-wysiwyg])'));
    });

    /**
     * Enable auto grow
     * @param textareas
     */
    self.enableAutosize = function(textareas) {
        if (typeof textareas !== 'undefined') {
            autosize(textareas);
        }
    };

    self.updateAutosize = function(textarea) {
        setTimeout(function() {
            if (typeof textarea === 'undefined') {
                autosize.update($('textarea[data-autosize]'));
            } else {
                autosize.update(textarea);
            }
        }, 0);
    };

    self.destroyAutosize = function(textarea) {
        if (typeof textarea === 'undefined') {
            autosize.destroy($('textarea[data-autosize]'));
        } else {
            autosize.destroy(textarea);
        }
    };


    self.enableCounter = function(textarea) {

        textarea.each(function() {
            var max;
            var counterSettings = $(this).data('counter');

            if (typeof counterSettings === 'number') {
                max = counterSettings;
            } else {
                max = Lib.Hash.get(counterSettings, 'max', false);
            }
            var inputGroup = $(this).closest('.input-group');
            var inputCountWrapper = inputGroup.find('.input-counter');
            var inputCount = inputCountWrapper.find('[data-count]');
            var hasValidationError = inputGroup.hasClass('error');
            $(this).on('keyup paste', function() {
                var $this = $(this);
                setTimeout(function() {
                    var currentCount = $this.val().length;
                    if (max) {
                        if (currentCount > max) {
                            inputGroup.addClass('error');
                            inputCountWrapper.addClass('text-danger');
                        } else {
                            inputCountWrapper.removeClass('text-danger');
                            if (!hasValidationError) {
                                inputGroup.removeClass('error');
                            }
                        }
                    }

                    inputCount.text(currentCount);

                }, 0);

            }).trigger('keyup');

        });


    };


    return self;

})();
